import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue'
import axios from 'axios'
import { useUserStore } from '@/stores/user'
import { API_BASE_URL } from '@/services/api'

interface Tariff {
  id: number
  Name: string
  group: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MyServices',
  setup(__props) {

const userStore = useUserStore()
const selectedTariff = ref(null)
const tariffs = ref([])
const submitting = ref(false)
const roamingEnabled = ref(false)
const snackbar = ref(false)
const snackbarText = ref('')
const snackbarColor = ref('success')

const getPhoneNumber = () => {
  return userStore.state?.context?.user?.phoneNumber?.substring(4) || ''
}

const showMessage = (text: string, color = 'success') => {
  snackbarText.value = text
  snackbarColor.value = color
  snackbar.value = true
}

const fetchTariffs = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/tariffs`)
    const items = response.data
    tariffs.value = items
      .filter((t: Tariff) => String(t.group) === '1')
      .map((item: Tariff) => ({
        title: item.Name || item.name,
        id: item.id
      }))
  } catch (error) {
    console.error('Error fetching tariffs:', error)
  }
}

const submitTariffChange = async () => {
  if (!selectedTariff.value) return
  submitting.value = true
  try {
    await axios.post(`${API_BASE_URL}/requests`, {
      phone: getPhoneNumber(),
      type: 'tariff_change',
      data: { tariff_id: selectedTariff.value }
    })
    showMessage('Заявка на смену тарифа отправлена')
    selectedTariff.value = null
  } catch (error: any) {
    const msg = error.response?.data?.error || 'Ошибка при отправке заявки'
    showMessage(msg, 'error')
  } finally {
    submitting.value = false
  }
}

const submitRoaming = async (newValue: boolean) => {
  submitting.value = true
  const type = newValue ? 'roaming_enable' : 'roaming_disable'
  try {
    await axios.post(`${API_BASE_URL}/requests`, {
      phone: getPhoneNumber(),
      type,
    })
    showMessage(newValue ? 'Заявка на включение роуминга отправлена' : 'Заявка на отключение роуминга отправлена')
  } catch (error: any) {
    const msg = error.response?.data?.error || 'Ошибка при отправке заявки'
    showMessage(msg, 'error')
    roamingEnabled.value = !newValue
  } finally {
    submitting.value = false
  }
}

const fetchOptions = async () => {
  const phone = getPhoneNumber()
  if (!phone) return
  try {
    const { data } = await axios.get(`${API_BASE_URL}/options?phone=${phone}`)
    roamingEnabled.value = data.roaming === '1'
  } catch (e) {
    console.error('Error fetching options:', e)
  }
}

watch(() => userStore.state.value, async (state) => {
  if (state === 'authenticated') {
    await Promise.all([fetchTariffs(), fetchOptions()])
  }
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("Смена тарифа")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_card_subtitle, null, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode(" Вы можете подать заявку на смену тарифа ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: selectedTariff.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTariff).value = $event)),
                        items: tariffs.value,
                        "item-title": "title",
                        "item-value": "id",
                        label: "Выберите новый тариф",
                        variant: "outlined"
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        disabled: !selectedTariff.value || submitting.value,
                        loading: submitting.value,
                        onClick: submitTariffChange
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode(" Подать заявку ")
                        ])),
                        _: 1
                      }, 8, ["disabled", "loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("Роуминг")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_switch, {
                        modelValue: roamingEnabled.value,
                        "onUpdate:modelValue": [
                          _cache[1] || (_cache[1] = ($event: any) => ((roamingEnabled).value = $event)),
                          submitRoaming
                        ],
                        label: roamingEnabled.value ? 'Роуминг включён' : 'Роуминг выключен',
                        color: "success",
                        loading: submitting.value,
                        disabled: submitting.value,
                        "hide-details": ""
                      }, null, 8, ["modelValue", "label", "loading", "disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_snackbar, {
        modelValue: snackbar.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((snackbar).value = $event)),
        color: snackbarColor.value,
        timeout: 4000
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(snackbarText.value), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "color"])
    ]),
    _: 1
  }))
}
}

})